/* Group actual CAD edges by their sampled geometry in the active workplane frame. */
(function(root){
  const dot=(a,b)=>a.reduce((sum,v,i)=>sum+v*b[i],0),sub=(a,b)=>a.map((v,i)=>v-b[i]),length=a=>Math.hypot(...a);
  function classify(edges,{transform=p=>p,normal=[0,1,0],bounds=null}={}){
    const size=length(normal)||1,axis=normal.map(v=>v/size);
    const samples=edges.map(edge=>({edge,points:(edge.points?.length?edge.points:[edge.start,...edge.mid?[edge.mid]:[],edge.end]).filter(Boolean).map(transform)}));
    const heights=samples.flatMap(item=>item.points.map(p=>dot(p,axis)));
    const low=bounds?.min??Math.min(...heights),high=bounds?.max??Math.max(...heights),tolerance=Math.max(.0001,(high-low)*.0001);
    const groups={top:[],bottom:[],vertical:[],horizontal:[],curved:[],straight:[]};
    for(const {edge,points}of samples){
      if(points.length<2)continue;
      const levels=points.map(p=>dot(p,axis)),min=Math.min(...levels),max=Math.max(...levels);
      if(levels.every(h=>Math.abs(h-high)<=tolerance))groups.top.push(edge);
      if(levels.every(h=>Math.abs(h-low)<=tolerance))groups.bottom.push(edge);
      if(max-min<=tolerance)groups.horizontal.push(edge);
      const first=points[0],last=points.at(-1),chord=sub(last,first),distance=length(chord);
      const straight=distance>tolerance&&points.every(p=>{
        const offset=sub(p,first),projection=dot(offset,chord)/(distance*distance);
        return length(offset.map((v,i)=>v-projection*chord[i]))<=Math.max(tolerance,distance*.0001);
      });
      groups[straight?'straight':'curved'].push(edge);
      if(straight&&max-min>tolerance&&points.every(p=>{const offset=sub(p,first),height=dot(offset,axis);return length(offset.map((v,i)=>v-height*axis[i]))<=Math.max(tolerance,distance*.0001);}))groups.vertical.push(edge);
    }
    return groups;
  }
  const api={classify};if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.MyersCADEdgeGroups=api;
})(typeof window!=='undefined'?window:globalThis);
